import React from 'react';
import { useNavigate } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';


const PrivacyPolicy = (props) => {
    const classes = useStyles();
    const navigation = useNavigate();

    return (
        <Box sx={{ backgroundImage: 'url(./mainbackground.svg)', backgroundSize: 'cover', height: '100vh' }}>
            <Grid container>
                <Box sx={{ backgroundColor: '#FFFFFF', margin: 8, height: '75vh', borderRadius: 5, boxShadow: 10, padding: 2 }} >
                    <Grid item sm={12} md={12}>
                        <Grid container sx={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Grid item sx={{ display: 'flex' }}>
                                <IconButton onClick={() => {navigation(-1)}}>
                                    <NavigateBeforeIcon sx={{ fontSize: '1.8rem', color: '#A9A9A9','@media (min-width: 1636px)':{
                  fontSize: '3rem'}  }} />
                                </IconButton>
                                <Typography sx={{ mt: 1, color: 'primary.main', fontWeight: '900', fontSize: '1.2rem' ,'@media (min-width: 1636px)':{
                  fontSize: '2rem'}}}>
                                    Privacy Policy
                                </Typography>
                            </Grid>
                            <Grid item sx={{ textAlign: 'right', pr: 4 }}>
                                <img
                                    src={require('../../assets/logo.png')}
                                    alt='Vocablab'
                                    loading="lazy"
                                    width='15%'
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item sm={12} md={12}>
                        <Box   sx={{ px: 2, py: 2, textAlign: 'justify',height: '12vh' }}>
                            <Typography sx={{ color: 'primary.main', fontWeight: "extraBold", fontSize: '0.9em', pl: 4, pr: 4,'@media (min-width: 1636px)':{
                  fontSize: '1.4rem'}  }}>What is personal information?</Typography>
                            <Typography sx={{ color: 'primary.main', fontSize: '0.8em', pl: 4, pr: 4, pt: 1,'@media (min-width: 1636px)':{
                  fontSize: '1.4rem'}  }}>
                                Personal Information' means information which uniquely identifies, contact, or locate an entity (individual or institution) through credentials like name, contact email address, contact phone for the purpose of fulfillment of services and support. Any information that falls outside of this is 'non-personal information'. Any non-personal information submitted to us combined shall be considered as personal information until removed from the data set stored with us. The personal information provided to us by you directly shall be used by us as per your permissions. Institutions using our site subscription may provide the minimum personal information of its members to adequately administer the activities and progress of its members.
                            </Typography>
                            <Typography sx={{ color: 'primary.main',  fontSize: '0.8em', pt: 2, pl: 4, pr: 4,'@media (min-width: 1636px)':{
                  fontSize: '1.4rem'}  }}>
                                Personal information or codes leading to such personal information including contacts and identity profiles obtained through third party authentication systems and/or device permissions granted for use of sensors, resources and functionality shall also be treated as personal information and bear the same set of privacy.
                            </Typography>
                            <Typography sx={{ color: 'primary.main', fontWeight: "extraBold", fontSize: '0.9em', pl: 4, pr: 4,pt: 2,'@media (min-width: 1636px)':{
                  fontSize: '1.4rem'}  }}>Transfer of data, storage and data services
                            </Typography>
                            <Typography sx={{ color: 'primary.main', fontSize: '0.8em', pl: 4, pr: 4, pt: 1,'@media (min-width: 1636px)':{
                  fontSize: '1.4rem'}  }}>
                                User data is handled securely including the transmission between devices and applications using necessary crypto protocols as necessary. Vocablab applications and apps hosted of various platform stores for distribution to clients inherently only requests authentication of identity for the use of its e-learning activities and feedback.
                            </Typography>
                            <Typography sx={{ color: 'primary.main', fontWeight: "extraBold", fontSize: '0.9em', pl: 4, pr: 4,pt: 2,'@media (min-width: 1636px)':{
                  fontSize: '1.4rem'}  }}>Our commitment</Typography>
                            <Typography sx={{ color: 'primary.main', fontSize: '0.8em', pl: 4, pr: 4, pt: 1,'@media (min-width: 1636px)':{
                  fontSize: '1.4rem'}  }}>
                                Your personal information shall be protected through physical, business and technical security measures. Security breach if any shall be conveyed to you for necessary action. The data shall be maintained until needed else shall be destroyed unless necessary by law. The data entrusted to us will not be shared, sold or used for any other purpose other than to purpose it was sought for and limited to providing access, support, service, feedback, important policy and feature notices.

                            </Typography>
                        </Box>
                    </Grid>
                </Box>
            </Grid>
        </Box>
    );
}
const useStyles = makeStyles({
    scrollBar: {
        '&::-webkit-scrollbar': {
            width: '0.2em'
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ffe600ff",
            '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
            borderRadius: 5
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#5f5600ff",
            borderRadius: 5
        }
    }
})
export default PrivacyPolicy;